import React, {useEffect, useState} from "react";
import AmountInfo from "./AmountInfo"
import { useTranslation } from 'react-i18next';
import ScholarshipService from "../services/ScholarshipService"
import DOMPurify from "dompurify";

export default function ScholarshipDetailInfo({scholarship}) {   
    const { t, i18n } = useTranslation();
    const [ scholarshipDetail, setScholarshipDetail ] = useState({});
   
    useEffect(()=>{
        ScholarshipService.getScholarship(scholarship.id, i18n.resolvedLanguage)
        .then(response => {
            setScholarshipDetail(response.data);
        })
        .catch(e => {
            console.log(e);
        });
    },[i18n.resolvedLanguage, scholarship.id])

    return (
        <>
            <div className="card is-bg-light">
                <div className="card-body">
                    <ul className="list-unstyled">
                    <li><strong>{t('scholarship.foundation_number')} </strong>{scholarship.stiftelseId}</li>
                    <li>
                        <strong>{t('scholarship.foundation')} </strong>
                        <a href="https://uaf.se/soek-stipendier/stiftelser">{scholarshipDetail.stiftelseNamn}</a>
                    </li>
                    <li><strong>{t('scholarship.category')}</strong> {scholarship.kategori}</li>
                    {(scholarship.nationer.length > 0 || scholarship.fakulteter.length > 0) &&
                        <li>
                            <strong>{t('scholarship.displayed_to')} </strong>
                            <span>{scholarship.nationer.concat(scholarship.fakulteter).join(', ')}</span>
                        </li>
                    }
                    {scholarship.fleraUniversitet &&
                        <li>{t('scholarship.other_universities')}</li>
                    }
                    {!scholarship.fleraUniversitet &&
                        <li>{t('scholarship.only_Uppsala_university')}</li>
                    }
                    </ul>
                </div>
            </div>
            <h3>{t('scholarship.title_announcement')}</h3>
            {scholarship.utlyst &&
                <p>{t('scholarship.open_for_application')} <br/>
                {t('scholarship.open_for_application_till')} {scholarship.ansokningsdatum} {scholarship.ansokningstid}.</p>
            }
            {!scholarship.utlyst &&
                <p>{t('scholarship.currently_not_open_for_application')}</p>
            }
            {scholarship.utlyst && scholarship.ordinarieUtlysningar && scholarship.ordinarieUtlysningar.length > 0 &&
            <><h4>{t('scholarship.ordinary_scholarships')}</h4>
                {scholarship.ordinarieUtlysningar.map((u, index) =>
                    <p key={index}><AmountInfo number={u.ordinarieAntal} amount={u.ordinarieBelopp} type={u.ordinarieBeloppTyp} /></p>
                )}</>
            }
            {scholarship.utlyst && scholarshipDetail && scholarshipDetail.extraAntal > 0 &&
                <><h4>{t('scholarship.extra_scholarships')}</h4>
                    <p><AmountInfo number={scholarshipDetail.extraAntal} amount={scholarshipDetail.extraBelopp} type={scholarshipDetail.extraBeloppTyp} /></p>
                </>
            }
            {scholarship.utlyst && scholarshipDetail && scholarshipDetail.kungorelsetexter && scholarshipDetail.kungorelsetexter.length > 0 &&
            <><h4>{t('scholarship.note')}</h4><p>{scholarshipDetail.kungorelsetexter}</p></>
            }
            <h3>{t('scholarship.title_scholarship_requirements')}</h3>
            <p>{scholarship.beskrivning}</p>

            {scholarshipDetail.slaktingar && scholarshipDetail.slaktingar.length > 0 && scholarshipDetail.foretradeSlakting && <strong>{t('scholarship.kinship_priority')}</strong>}
            {scholarshipDetail.slaktingar && scholarshipDetail.slaktingar.length > 0 && !scholarshipDetail.foretradeSlakting && <strong>{t('scholarship.kinship_mentioned')}</strong>}
            {scholarshipDetail.slaktingar}

            <div className="card is-bg-light mb-1 mt-3">
                <div className="card-body">
                    <h3>{t('scholarship.title_attachment')}</h3>
                    {scholarshipDetail && scholarshipDetail.bilagstyper &&
                        scholarshipDetail.bilagstyper.map(b =>
                            <div>
                                <button className="toggle-button button-text button-icon" data-bs-toggle="collapse" data-bs-target={"#toggle-" + scholarship.id + b.id} aria-controls="toggle-button" aria-expanded="false">{b.namn}</button>
                                <div key={scholarship.id + b.id}  id={"toggle-" + scholarship.id + b.id} className="toggle-content collapse">
                                    <div className="card">
                                        <div className="card-body">
                                             <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(b.text) }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}